import * as z from "zod";

/** Team settings that gate a notification on top of its automation. */
export const ReturnsShopperNotificationsSettingsChangesSchema = z.object({
  labelExpiration: z
    .object({ reminderEmails: z.boolean(), expirationEmails: z.boolean() })
    .partial()
    .optional(),
});

export type ReturnsShopperNotificationsSettingsChanges = z.infer<
  typeof ReturnsShopperNotificationsSettingsChangesSchema
>;

/** The slice of `team.settings` these notifications read. */
export interface ReturnsShopperNotificationsSettingsSource {
  labelExpiration?: {
    reminderEmails?: boolean | null;
    expirationEmails?: boolean | null;
  } | null;
}

/** Writes only values that differ from what's stored. */
export function returnsShopperNotificationsTeamPatchForChanges(
  settings: ReturnsShopperNotificationsSettingsSource,
  changes: ReturnsShopperNotificationsSettingsChanges,
): { set: Record<string, unknown>; unset: string[] } {
  const stored = settings.labelExpiration;
  const requested = changes.labelExpiration;
  const set: Record<string, unknown> = {};
  if (
    requested?.reminderEmails !== undefined &&
    requested.reminderEmails !== !!stored?.reminderEmails
  ) {
    set["labelExpiration.reminderEmails"] = requested.reminderEmails;
  }
  if (
    requested?.expirationEmails !== undefined &&
    requested.expirationEmails !== !!stored?.expirationEmails
  ) {
    set["labelExpiration.expirationEmails"] = requested.expirationEmails;
  }
  return { set, unset: [] };
}
